import { handleActions } from "redux-actions";
import {
    clearConfigCITests,
    getConfigCITests,
    getConfigCITestsError,
    getConfigCITestsSuccess,
    mergeTestCases,
    setTestCases
} from "modules/ConfigCI/services/ConfigCITests/actions";

const initialState = {
    isLoading: false,
    config_ci_test_tasks: [],
    testCases: {},
    count: 0
};

export const configCITestsReducer = handleActions(
    {
        [clearConfigCITests]: () => ({ ...initialState }),

        [setTestCases]: (state, { payload }) => ({
            ...state,
            testCases: payload
        }),
        [mergeTestCases]: (state, { payload }) => ({
            ...state,
            testCases: {
                ...state.testCases,
                ...payload
            }
        }),

        [getConfigCITests]: (state) => ({
            ...state,
            isLoading: true
        }),
        [getConfigCITestsSuccess]: (state, { payload }) => ({
            ...state,
            isLoading: false,
            ...payload
        }),
        [getConfigCITestsError]: (state) => ({
            ...state,
            isLoading: false
        })
    },
    initialState
);
